import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./css/app.css";
import "./css/icons.css";
import "./styles/assets/fonts/fonts.css";
import { GlobalStyle } from "./styles/global-style";
import { BrowserRouter } from "react-router-dom";

// ReactDOM.render(React.createElement(App), document.getElementById("app"));
const root = ReactDOM.createRoot(document.getElementById("app") as HTMLElement);
root.render(
  <>
    <BrowserRouter>
      <GlobalStyle />
      <App />
    </BrowserRouter>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
